// Generated by ts-to-zod
import { z } from 'zod';
import { schemaUiConfigTypeSchema } from '../../schemas/models/schemaDatapointBase.schema';
import { urlSchema } from '../../types.schema';

export const configurationMapFieldSchema = z.object({
  id: z.string(),
  type: z.union([schemaUiConfigTypeSchema, z.literal('external')]),
  dependencies: z.array(z.string()).optional(),
});

export const configurationMapEdgeSchema = z.object({
  source: z.string(),
  target: z.string(),
});

export const configurationMapRuleSchema = z.object({
  id: z.string(),
  name: z.string(),
  ruleId: z.number(),
  enabled: z.boolean(),
  dependencies: z.array(z.string()),
  error: z.string().optional(),
});

export const configurationMapHookSchema = z.object({
  id: z.string(),
  name: z.string(),
  hookId: z.number(),
  hookType: z.union([z.literal('function'), z.literal('webhook')]),
  active: z.boolean(),
  dependencies: z.array(z.string()),
  targets: z.array(z.string()),
  error: z.string().optional(),
});

export const configurationMapResponseSchema = z.object({
  results: z.object({
    fields: z.array(configurationMapFieldSchema),
    edges: z.array(configurationMapEdgeSchema),
    rules: z.array(configurationMapRuleSchema),
    hooks: z.array(configurationMapHookSchema),
  }),
});

export const configurationMapPayloadSchema = z.object({
  queue: urlSchema,
  updatedDatapointIds: z.array(z.string()).optional(),
  actions: z.array(z.string()).optional(),
  hookEvents: z.array(z.string()).optional(),
});
